import { call, put, takeLatest, all, select } from 'redux-saga/effects';
import _ from 'lodash';
import { orgId, Ajax } from 'utils';
import { selectCheckedShowIncidentSub } from 'state/selectors/subscriptionSelectors';
import * as actionTypes from '../actions/actionTypes';
import * as subscriptionActions from '../actions/subscriptionActions';
import { encode64, formatFormData } from '../../utils/ebUtils';

// group
export function* getGroupSubscriptionList({ payload: { contactId } }) {
  try {
    const url = `/${orgId}/${contactId}/groupSubscriptions`;
    const { status, data: result } = yield call(Ajax.get, url);

    if (status === 200) {
      const optInGroups = _.get(result, 'optInGroup', '');
      const selectedGroupIds = _.get(result, 'selectedGroupIds', []);
      optInGroups.groups.forEach((item) => {
        item.level = 'one';
      });
      const payload = {
        optInGroups,
        selectedGroupIds,
      };
      yield put(subscriptionActions.getGroupSubscriptionList.success(payload));
    } else {
      yield put(subscriptionActions.getGroupSubscriptionList.fail({
        status
      }));
    }
  } catch (error) {
    yield put(subscriptionActions.getGroupSubscriptionList.fail(error));
  }
}

export function* watchGetGroupSubscriptionList() {
  yield takeLatest(actionTypes.GET_GROUP_SUBSCRIPTION.ACTION, getGroupSubscriptionList);
}

export function* updateGroupSubscriptionList({
  payload: { successCallback, failCallback, contactId, ...data }
}) {
  try {
    const url = `/${orgId}/${contactId}/groupSubscriptions`;
    const { data: result } = yield call(Ajax.put, url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const resultData = _.get(result, 'result', '');
    if (resultData === true) {
      successCallback();
    } else {
      failCallback();
    }
  } catch (error) {
    yield put(subscriptionActions.updateGroupSubscriptionList.fail(error));
  }
}

export function* watchUpdateGroupSubscriptionList() {
  yield takeLatest(actionTypes.UPDATE_GROUP_SUBSCRIPTION.ACTION, updateGroupSubscriptionList);
}

export function* updateAlertSubscriptionList({
  payload: { contactId, nodisturb, subs, successCallback, failCallback }
}) {
  try {
    const url = `/${orgId}/${contactId}/subscriptions`;
    const data = {
      rs: encode64(JSON.stringify(subs)),
      rsNodisturb: encode64(JSON.stringify(nodisturb))
    };
    const formattedParams = formatFormData(data);
    const { data: result } = yield call(Ajax.post, url, formattedParams, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const status = _.get(result, 'status', '');
    if (status === 'yes') {
      successCallback();
    } else {
      failCallback();
    }
  } catch (error) {
    yield put(subscriptionActions.updateAlertSubscriptionList.fail(error));
  }
}

export function* watchUpdateAlertSubscriptionList() {
  yield takeLatest(actionTypes.UPDATE_ALERT_SUBSCRIPTION.ACTION, updateAlertSubscriptionList);
}
// incident
export function* getIncidentSubscriptionList() {
  try {
    const url = '/rest/incident/subscription/contactIdAndGroupIds';
    const { status, data: result } = yield call(Ajax.get, url);
    const message = _.get(result, 'message', '');
    const type = _.get(result, 'type', '');
    const resultData = _.get(result, 'data', '');
    const payload = {
      message,
      type,
      resultData,
    };
    if (status === 200) {
      yield put(subscriptionActions.getIncidentSubscriptionList.success(payload));
    } else {
      yield put(subscriptionActions.getIncidentSubscriptionList.fail({
        status
      }));
    }
  } catch (error) {
    yield put(subscriptionActions.getIncidentSubscriptionList.fail(error));
  }
}

export function* watchGetIncidentSubscriptionList() {
  yield takeLatest(actionTypes.GET_INCIDENT_SUBSCRIPTION.ACTION, getIncidentSubscriptionList);
}

export function* updateIncidentSubscriptionList(action) {
  try {
    const { successCallback, failCallback } = action.payload;
    const url = '/rest/incident/subscription/assign';
    const formattedParams = formatFormData(action.payload);
    const { data: result } = yield call(Ajax.put, url, formattedParams, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    const resultData = _.get(result, 'result', '');
    if (resultData === 'true') {
      _.attempt(successCallback, { message: 'ssp.save.success', success: true });
    } else {
      _.attempt(failCallback, {
        success: false,
      });
    }
  } catch (error) {
    yield put(subscriptionActions.updateIncidentSubscriptionList.fail(error));
  }
}

export function* checkShowIncidentSub({
  payload: { contactId,
    csrfToken,
    showAlertSubscription,
    showGroupSubscription,
    showIncidentSub }
}) {
  const checkedShowIncidentSub = yield select(selectCheckedShowIncidentSub);

  if (!checkedShowIncidentSub && contactId && csrfToken) {
    // check after logged in with account
    if (!showIncidentSub) {
      yield put(subscriptionActions.setShouldShowIncidentSub(false));
    } else if (showAlertSubscription || showGroupSubscription) {
      yield put(subscriptionActions.setShouldShowIncidentSub(true));
    } else {
      const [
        { status: groupsStatus, data: groupsResponse },
        { status: topicsStatus, data: topicsResponse },
      ] = yield all([
        call(Ajax.get, '/rest/incident/subscription/contactIdAndGroupIds'),
        call(Ajax.get, `/rest/incident/subscription/topics?contact=${contactId}`),
      ]);

      if (groupsStatus === 200 && topicsStatus === 200) {
        const groupInfos = _.get(groupsResponse, 'data[groupInfo]', []);
        const topicInfos = topicsResponse || [];
        const groupIds = groupInfos.map(gi => gi.groupId);
        const topicIds = topicInfos.map(ti => ti.topicId);

        const { status: searchStatus, data: searchResult } = yield call(
          Ajax.post,
          `/member-portal-gateway/api/cmdb/lookup/${orgId}/subscriptions/alerts/search`,
          {
            published: true,
            ebTopics: topicIds.join(','),
            groups: groupIds.join(','),
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'X-CSRF-TOKEN': csrfToken,
            },
          }
        );

        const shouldShowIncidentSub = !!(
          searchStatus === 200 &&
                    searchResult &&
                    searchResult.data &&
                    searchResult.data.length &&
                    searchResult.data.length > 0
        );

        yield put(subscriptionActions.setShouldShowIncidentSub(shouldShowIncidentSub));
      }
    }
  }
}

export function* watchCheckShowIncidentSub() {
  yield takeLatest(actionTypes.CHECK_SHOW_INCIDENT_SUBSCRIPTION.ACTION, checkShowIncidentSub);
}

export function* watchUpdateIncidentSubscriptionList() {
  yield takeLatest(actionTypes.UPDATE_INCIDENT_SUBSCRIPTION.ACTION, updateIncidentSubscriptionList);
}
